import {useEffect, useState} from "react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useBoundStore} from "../../../Store/store";
import {BaseCard} from "../../../Components/Cards/BaseCard";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {ShiftInfoCard} from "../../../Components/Cards/ShiftInfoCard";
import dayjs from "dayjs";

export const ApplicationDetail = () => {
    const { applicationId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const getApplicationDetail = useBoundStore(state => state.getApplicationDetail);
    const applicationDetail = useBoundStore(state => state.applicationDetail);
    
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        getApplicationDetail(applicationId).finally(() => {
            setIsLoading(false);
        });
    }, [getApplicationDetail, applicationId]);

    if (isLoading) {
        return (
            <div>
                <div className={'flex flex-row justify-between mb-4 items-center'}>
                    <div>
                        <h1 className={'text-2xl font-semibold'}>{t('customer.application_detail.title')}</h1>
                        <div
                            className={"flex flex-row group items-center cursor-pointer"}
                            onClick={() => navigate('/customer/applications')}
                        >
                            <FontAwesomeIcon
                                icon={faArrowLeft}
                                className={'text-sm transition-all group-hover:mr-2 duration-500'}
                            />
                            <div className={'text-sm text-gray-500 ml-2'}>
                                {t('general.actions.back_to_overview')}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                    <div className={'md:col-span-2'}>
                        <BaseCard border={false}>
                            <div className="flex flex-col items-center justify-center py-12">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                                <p className="mt-4 text-gray-500">{t('general.messages.loading_data')}</p>
                            </div>
                        </BaseCard>
                    </div>
                    <BaseCard border={false}>
                        <div className="flex items-center justify-center py-12">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                        </div>
                    </BaseCard>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className={'flex flex-row justify-between mb-4 items-center'}>
                <div>
                    <h1 className={'text-2xl font-semibold'}>{t('customer.application_detail.title')}</h1>
                    <div
                        className={"flex flex-row group items-center cursor-pointer"}
                        onClick={() => navigate('/customer/applications')}
                    >
                        <FontAwesomeIcon
                            icon={faArrowLeft}
                            className={'text-sm transition-all group-hover:mr-2 duration-500'}
                        />
                        <div className={'text-sm text-gray-500 ml-2'}>
                            {t('general.actions.back_to_overview')}
                        </div>
                    </div>
                </div>
            </div>

            <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                <div className={'md:col-span-2'}>
                    <BaseCard border={false}>
                        <h2 className="text-lg text-gray-700 uppercase mb-4">{t('general.labels.global_information')}</h2>
                        <div className="space-y-2">
                            <ReadOnlyField label="Application ID" value={applicationDetail?.id} />
                            <ReadOnlyField label="Status" value={applicationDetail?.status} />
                            <ReadOnlyField
                                label="In Progress"
                                value={applicationDetail?.in_progress ? t('general.yes') : t('general.no')}
                            />
                            <ReadOnlyField
                                label="Accepted At"
                                value={
                                    applicationDetail?.accepted_at?.locale
                                        ? dayjs(applicationDetail.accepted_at.locale).format('YYYY-MM-DD HH:mm')
                                        : t('general.not_applicable')
                                }
                            />

                            <ReadOnlyField
                                label="Applied At"
                                value={
                                    applicationDetail?.applied_at?.locale
                                        ? dayjs(applicationDetail.applied_at.locale).format('YYYY-MM-DD HH:mm')
                                        : t('general.not_applicable')
                                }
                            />
                        </div>
                    </BaseCard>
                </div>

                <BaseCard border={false}>
                    <ShiftInfoCard shift={applicationDetail?.shift} />
                </BaseCard>
            </div>
        </div>
    );
};

function ReadOnlyField({ label, value }) {
    return (
        <div className="flex flex-col">
            <label className="text-sm text-gray-500">{label}</label>
            <div className="text-base text-gray-800">{value !== null && value !== undefined ? value : '-'}</div>
        </div>
    );
}
